import { useCallback } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useSessionTimeout } from '@/features/auth/hooks/useSessionTimeout';
import { Modal } from '@chikara/ui';
import { APP_CONFIG } from '@/config';
import styles from './SessionTimeoutManager.module.css';
import { t } from '@/i18n';

// Default times or loaded from config if available
// Assuming APP_CONFIG doesn't have these explicitly yet, we fallback to our DoD
const IDLE_TIMEOUT_MS = (APP_CONFIG.session as any)?.idleTimeoutMs || 900000; // 15 min default
const WARNING_DURATION_MS = (APP_CONFIG.session as any)?.warningDurationMs || 60000; // 60s default

export function SessionTimeoutManager() {
  const { isAuthenticated, logout } = useAuth();

  const handleTimeout = useCallback(() => {
    logout();
  }, [logout]);

  const { isWarning, countdown, resetTimer } = useSessionTimeout(
    IDLE_TIMEOUT_MS,
    WARNING_DURATION_MS,
    handleTimeout
  );

  if (!isAuthenticated || !isWarning) {
    return null;
  }

  return (
    <Modal
      isOpen={isWarning}
      onClose={resetTimer}
      title={t('sessionTimeout.title')}
      actionLabel={t('sessionTimeout.action')}
      onAction={logout}
      secondaryActionLabel={t('sessionTimeout.secondaryAction')}
      onSecondaryAction={resetTimer}
      secondaryActionVariant="button"
      closeOnEsc={false}
      closeOnOverlayClick={false}
      showCloseButton={false}
    >
      <div className={styles.container}>
        <div className={styles.timerCircle}>
          <span className={styles.timerNumber}>{countdown}</span>
          <span className={styles.timerUnit}>{t('sessionTimeout.timerUnit')}</span >
        </div>
        <p className={styles.description}>
          {t('sessionTimeout.description')}
        </p>
      </div>
    </Modal>
  );
}
